import { render } from "./Activation.vue?vue&type=template&id=04b64359"
import script from "./Activation.vue?vue&type=script&lang=js"
export * from "./Activation.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__